<template>
  <div class="fourth-page">
    <!-- 标题区域 -->
    <div class="fourth-page-name">玖聚团队</div>
    <div class="fourth-page-content">
      建设一支职业道德高尚、执业纪律严明、业务精湛、勤业敬业、诚实守信的律师队伍
    </div>

    <!-- 轮播容器 -->
    <div class="carousel-wrapper">
      <!-- 左箭头 -->
      <div class="carousel-arrow left" @click="prev">
        <i class="icon-arrow"></i>
      </div>

      <!-- 轮播内容区 -->
      <div class="carousel-container">
        <div
            class="carousel-track"
            :style="{ transform: `translateX(-${currentIndex * 25}%)`, transition: 'transform 0.5s ease' }"
        >
          <div class="carousel-item" v-for="(item, index) in dataList" :key="item.id">
            <div class="member-card">
              <img :src="item.imgPink" alt="成员照片" class="member-img">
              <div class="member-info">
                <div class="name-position">
                  <span class="name">{{ item.name }}</span>
                  <span class="position">/ {{ item.position }}</span>
                </div>
                <div class="expertise">
                  擅长领域：{{ item.careerField || '暂无信息' }}
                </div>
                <div class="view-detail" @click="viewDetail(item)">
                  查看详情
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右箭头 -->
      <div class="carousel-arrow right" @click="next">
        <i class="icon-arrow"></i>
      </div>
    </div>

    <!-- 轮播指示器 -->
    <div class="carousel-dots">
      <span
          class="dot"
          v-for="(item, index) in totalSlides"
          :key="index"
          :class="{ active: index === currentSlide }"
          @click="goToSlide(index)"
      ></span>
    </div>

    <!-- 了解更多 -->
    <div class="learn-more" @click="learnMore">了解更多 →</div>
    <div class="pageNum">
      <img width="26px" height="13px" src="../../assets/homePage/home_icon_npage.png" @click="goNextPage"/>
    </div>
  </div>
</template>

<script>
import dataList from '@/views/jiujuTeam/data'; // 引入团队成员数据

export default {
  name: 'jiujutuandui',
  data() {
    return {
      dataList,
      currentIndex: 0, // 当前轮播索引
      itemsPerPage: 4, // 每页显示的项目数
      totalSlides: 0 // 总页数
    };
  },
  computed: {
    currentSlide() {
      return Math.floor(this.currentIndex / this.itemsPerPage);
    }
  },
  mounted() {
    // 计算总页数
    this.totalSlides = Math.ceil(this.dataList.length / this.itemsPerPage);
  },
  methods: {
    // 上一页
    prev() {
      if (this.currentIndex === 0) {
        // 如果当前是第一页，则跳转到最后一页
        this.currentIndex = this.dataList.length - this.itemsPerPage;
      } else {
        this.currentIndex -= this.itemsPerPage;
      }
    },
    // 下一页
    next() {
      if (this.currentIndex >= this.dataList.length - this.itemsPerPage) {
        // 如果当前是最后一页，则跳转到第一页
        this.currentIndex = 0;
      } else {
        this.currentIndex += this.itemsPerPage;
      }
    },
    // 跳转到指定页
    goToSlide(slideIndex) {
      this.currentIndex = slideIndex * this.itemsPerPage;
    },
    // 查看详情
    viewDetail(val) {
      // 可添加路由跳转逻辑，例如：
      this.$router.push({
        path: '/jiujuTeam/personalInfo',
        query: {
          id: val.id,
        }
      })
    },
    learnMore() {
      this.$router.push({
        path: '/jiujuTeam',
      })
    },
    goNextPage() {
      this.$emit('next-page'); // 触发一个事件，通知父组件跳转到下一页
    },
  }
};
</script>

<style lang="scss" scoped>
.fourth-page {
  width: 100%;
  height: 100vh;
  background: url("../../assets/img/lstd.png") no-repeat center center;
  background-size: cover;
  padding: 10vh 10vw;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  // 标题样式
  .fourth-page-name {
    font-weight: 500;
    font-size: 56px;
    color: #FFFFFF;
    line-height: 66px;
    margin-bottom: 2vh;
  }

  .fourth-page-content {
    font-weight: 400;
    font-size: 24px;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 5vh;
  }

  // 轮播容器
  .carousel-wrapper {
    position: relative;
    margin: 0 auto;
  }

  // 轮播内容区
  .carousel-container {
    width: 100%;
    overflow: hidden; // 隐藏超出部分
  }

  .carousel-track {
    display: flex;
    height: 100%;
  }

  .carousel-item {
    width: 25%; // 每个项目占25%宽度，一页显示4个
    flex-shrink: 0; // 禁止收缩
    padding: 0 15px;
    box-sizing: border-box;
  }

  // 成员卡片样式
  .member-card {
    width: 100%;
    background-color: #fff;
    overflow: hidden;
    position: relative;

    &:hover {
      // 卡片hover时，触发查看详情按钮样式变化
      .view-detail {
        visibility: visible; // 显示：视觉可见
        opacity: 1;          // 透明度：完全不透明
        background-color: #AD867E;
        color: #fff;
      }
    }
  }

  .member-img {
    width: 100%;
    object-fit: cover; // 保持图片比例
  }

  .member-info {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
    .name-position {
      margin-bottom: 15px;
      margin-left: 5%;

      .name {
        font-weight: 500;
        font-size: 18px;
        color: #333333;
      }

      .position {
        font-weight: 400;
        font-size: 14px;
        color: #AD867E;
        margin-left: 8px;
      }
    }

    .expertise {
      width: 264px;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 1.6;
      margin-bottom: 20px;
      margin-left: 5%;
      margin-right: auto;
      white-space: nowrap; /* 禁止文本换行，强制单行显示 */
      overflow: hidden; /* 隐藏超出容器宽度的文本 */
    }

  }
  .view-detail {
    width: 100%;
    visibility: hidden;
    opacity: 0;
    background-color: transparent; // 隐藏时透明背景，避免残留
    height: 32px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #fff;
  }

  // 指示器样式
  .carousel-dots {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 40px;

    .dot {
      width: 30px;
      height: 6px;
      border-radius: 12px;
      background-color: rgba(255, 255, 255, 0.3);
      cursor: pointer;
      transition: all 0.3s ease;

      &.active {
        background-color: #fff;
        width: 30px;
        border-radius: 6px;
      }
    }
  }

  // 了解更多
  .learn-more {
    position: absolute;
    bottom: 5vh;
    left: 10vw;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.8;
    }
  }
  .pageNum{
    width: calc(100% - 20vw);
    text-align: center;
    position: absolute;
    bottom: 20px;
    cursor: pointer;
  }
}


</style>
